import { useMemo } from 'react';

const COLORS = ['#f5c542', '#3dd5ff', '#b76bff', '#4ad06b', '#ff8484', '#ff9a3c'];

export function ConfettiBurst() {
  const pieces = useMemo(
    () =>
      Array.from({ length: 24 }, (_, i) => ({
        id: i,
        color: COLORS[i % COLORS.length],
        cx: (Math.random() - 0.5) * 280,
        cr: Math.random() * 720 - 360,
        delay: Math.random() * 200,
        // Originate from a tighter zone near the WIN headline (~22-38% from
        // EndScreen top), not the middle of the overlay. Reads as a burst
        // FROM the title, not a generic top-down rain.
        left: 50 + (Math.random() - 0.5) * 22,
        top: 22 + Math.random() * 16,
        shape: i % 3,
      })),
    [],
  );

  return (
    <div
      aria-hidden="true"
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 5 }}
    >
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti"
          style={{
            left: `${p.left}%`,
            top: `${p.top}%`,
            background: p.color,
            boxShadow: `0 0 6px ${p.color}88`,
            borderRadius: p.shape === 0 ? '50%' : p.shape === 1 ? '2px' : '0',
            ['--cx' as never]: `${p.cx}px`,
            ['--cr' as never]: `${p.cr}deg`,
            animationDelay: `${p.delay}ms`,
          } as React.CSSProperties}
        />
      ))}
    </div>
  );
}
